import { LegalPage, LegalSection } from "@/components/LegalPage";

// Contenido provisional. Sustituir por el texto legal definitivo antes
// del lanzamiento comercial en producción.

export default function Terms() {
    return (
        <LegalPage
            title="Términos de Servicio"
            updatedAt="2026-02-01"
            testId="terms-page-root"
        >
            <p>
                Bienvenido/a a <strong>Loving Angels</strong>. Estos Términos
                de Servicio regulan el uso de nuestra plataforma para crear y
                gestionar invitaciones digitales de boda. Al utilizar el
                servicio aceptas estos términos íntegramente. Por favor
                léelos con calma; están escritos en un lenguaje claro y sin
                letra pequeña.
            </p>

            <LegalSection title="1. Aceptación del servicio" id="aceptacion">
                <p>
                    Al iniciar sesión con tu cuenta de Google en Loving
                    Angels aceptas quedar vinculado/a por estos Términos y
                    por nuestra{" "}
                    <a href="/privacy" className="underline underline-offset-2">
                        Política de Privacidad
                    </a>
                    . Si no estás de acuerdo con alguna de las cláusulas, te
                    pedimos que no utilices el servicio.
                </p>
            </LegalSection>

            <LegalSection title="2. Descripción del servicio" id="descripcion">
                <p>
                    Loving Angels es una plataforma que permite a parejas
                    diseñar una web de boda, gestionar RSVP, dietas y datos
                    logísticos, y publicarla en internet bajo una URL propia
                    en el dominio <code>lovingangels.es</code>.
                </p>
                <p>
                    El diseño de la web es gratuito. La publicación online
                    requiere un pago único de <strong>39 €</strong>, sin
                    cuotas ni renovaciones.
                </p>
            </LegalSection>

            <LegalSection title="3. Cuenta y responsabilidad" id="cuenta">
                <p>
                    La autenticación se realiza mediante Google. Eres
                    responsable de mantener la seguridad de tu cuenta de
                    Google asociada. Loving Angels no almacena contraseñas.
                </p>
                <p>
                    Cada cuenta de usuario está vinculada a una única web de
                    boda. Si necesitas gestionar varias bodas (por ejemplo,
                    como wedding planner), contacta con nosotros.
                </p>
            </LegalSection>

            <LegalSection title="4. Pago y publicación" id="pago">
                <p>
                    El pago único de 39 € se realiza a través de{" "}
                    <strong>Stripe</strong>, procesador de pagos externo
                    certificado PCI-DSS. Loving Angels no almacena ni tiene
                    acceso a los datos de tu tarjeta.
                </p>
                <p>
                    Tras un pago exitoso, tu web se publica de forma
                    permanente mientras el servicio siga operativo. En caso
                    de cese de la plataforma te avisaremos con antelación
                    suficiente para descargar tus datos.
                </p>
            </LegalSection>

            <LegalSection title="5. Contenido del usuario" id="contenido">
                <p>
                    Todo el contenido que subas (nombres, textos, fotos,
                    listas de invitados) sigue siendo de tu propiedad. Nos
                    concedes una licencia limitada para almacenarlo y
                    mostrarlo públicamente solo en tu web de boda.
                </p>
                <p>
                    Te comprometes a no subir contenido ilegal, ofensivo o
                    que vulnere derechos de terceros. Podemos retirar
                    contenido que incumpla esta cláusula previo aviso.
                </p>
            </LegalSection>

            <LegalSection title="6. Reembolsos" id="reembolsos">
                <p>
                    Puedes solicitar el reembolso del pago único en un plazo
                    de 14 días desde la publicación, siempre que no hayas
                    compartido la URL pública con invitados. Escríbenos a{" "}
                    <a
                        href="mailto:hola@lovingangels.es"
                        className="underline underline-offset-2"
                    >
                        hola@lovingangels.es
                    </a>{" "}
                    con el email de tu cuenta.
                </p>
            </LegalSection>

            <LegalSection title="7. Limitación de responsabilidad" id="responsabilidad">
                <p>
                    Loving Angels no será responsable de daños indirectos
                    derivados del uso o imposibilidad de uso del servicio,
                    incluyendo pero no limitándose a: pérdida de datos,
                    incidencias en el día de la boda causadas por terceros,
                    o retrasos en la disponibilidad del servicio.
                </p>
            </LegalSection>

            <LegalSection title="8. Modificaciones" id="modificaciones">
                <p>
                    Podemos actualizar estos Términos ocasionalmente. Te
                    avisaremos por email de cambios sustanciales. El uso
                    continuado del servicio tras la notificación implica
                    aceptación de los nuevos términos.
                </p>
            </LegalSection>

            <LegalSection title="9. Ley aplicable" id="ley">
                <p>
                    Estos Términos se rigen por la legislación española. Los
                    juzgados y tribunales del domicilio del consumidor
                    serán competentes para resolver cualquier controversia.
                </p>
            </LegalSection>

            <LegalSection title="10. Contacto" id="contacto">
                <p>
                    Para cualquier pregunta relativa a estos Términos:{" "}
                    <a
                        href="mailto:hola@lovingangels.es"
                        className="underline underline-offset-2"
                    >
                        hola@lovingangels.es
                    </a>
                </p>
            </LegalSection>
        </LegalPage>
    );
}
